import axios from 'axios';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export interface PublicAdmissionCenter {
  slug: string;
  name: string;
}

export interface PublicAdmissionClass {
  id: string;
  name: string;
  minDob: string | null;
  maxDob: string | null;
  message: string | null;
}

export interface PublicAdmissionSection {
  id: string;
  name: string;
}

export interface PublicAdmissionSchoolContact {
  name: string;
  contact: string | null;
}

export interface ApplyOnlineAdmissionPayload {
  name: string;
  gender: 'male' | 'female';
  dob: string;
  mobile: string;
  whatsapp?: string;
  fatherName: string;
  classId: string;
  sectionId: string;
  place: string;
  sourceOfInfo?: string;
}

/**
 * Online Admission — the public application form. No auth (raw axios, not
 * the tenant-scoped `api` instance — there's no logged-in session and no
 * X-School-Code header to attach). Server-side dob validation on submit is
 * the real gate (see backend OnlineAdmissionPublicService's doc comment) —
 * the class list here is a convenience filter, not the enforcement point.
 */
export const OnlineAdmissionPublicApi = {
  /** "Select Center" — active schools with at least one class open for online admission (matches legacy publicCreate()). */
  listCenters: async (): Promise<PublicAdmissionCenter[]> => unwrap(await axios.get(`/api/v1/public/online-admission/centers`)),

  listClasses: async (schoolSlug: string, dob?: string): Promise<PublicAdmissionClass[]> =>
    unwrap(await axios.get(`/api/v1/public/online-admission/${schoolSlug}/classes`, { params: dob ? { dob } : undefined })),

  listSections: async (schoolSlug: string, classId: string): Promise<PublicAdmissionSection[]> =>
    unwrap(await axios.get(`/api/v1/public/online-admission/${schoolSlug}/classes/${classId}/sections`)),

  apply: async (schoolSlug: string, payload: ApplyOnlineAdmissionPayload): Promise<{ id: string; school: PublicAdmissionSchoolContact }> =>
    unwrap(await axios.post(`/api/v1/public/online-admission/${schoolSlug}/apply`, payload)),
};
